import { instanceApi } from '../../../services';

export const getMasterIBCommissionReportDetail = (params: any): Promise<any> =>
  instanceApi.get(`rebate/report/getmasteribcommissionreportdetail`, {
    params,
  });

export const getReports = (params: any): Promise<any> => instanceApi.get(`rebate/report/getmasteribcommissionreport`, { params });
